import { gql } from '@apollo/client'

export const GET_ACCOUNT_MANAGERS = gql`
  query GET_ACCOUNT_MANAGERS(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [CustomerOrderByWithRelationInput!]
    $roles: [CustomerRole]
    $filters: [CustomerWhereInput!]
  ) {
    findManyCustomerCount(
      where: {
        AND: [
          {
            OR: [
              { account_code: { mode: insensitive, contains: $searchTerm } }
              { name: { mode: insensitive, contains: $searchTerm } }
              { surname: { mode: insensitive, contains: $searchTerm } }
              { b2b_company_name: { mode: insensitive, contains: $searchTerm } }
            ]
          }
          { is_b2b_user: { equals: true } }
          { role: { in: $roles } }
          { AND: $filters }
        ]
      }
    )

    findManyCustomer(
      orderBy: $orderBy
      where: {
        AND: [
          {
            OR: [
              { account_code: { mode: insensitive, contains: $searchTerm } }
              { name: { mode: insensitive, contains: $searchTerm } }
              { surname: { mode: insensitive, contains: $searchTerm } }
              { b2b_company_name: { mode: insensitive, contains: $searchTerm } }
            ]
          }
          { is_b2b_user: { equals: true } }
          { role: { in: $roles } }
          { AND: $filters }
        ]
      }
      take: $take
      skip: $skip
    ) {
      id
      createdAt
      name
      surname
      email
      default_phone_number
      language
      account_code
      buying_as_company
      is_b2b_user
      b2b_company_name
      b2b_customer_discount
      b2b_company_country
      orders {
        id
      }
      role
      _count {
        managed_customers
      }
    }
  }
`

export const DELETE_SINGLE_B2B_CUSTOMER = gql`
  mutation DELETE_SINGLE_B2B_CUSTOMER($id: Int!) {
    deleteSingleB2BCustomer(id: $id)
  }
`

export const CORE_B2B_CUSTOMER_DATA = gql`
  fragment CoreB2BCustomerData on Customer {
    id
    createdAt
    updatedAt
    name
    surname
    email
    language
    account_code
    spoken_languages
    b2b_company_name
    default_phone_number
    role
    price_listId
    fabric_palettes {
      id
    }

    imageId
    image {
      id
      src_md
      src
    }
    is_configurator_enabled
    is_claims_enabled
    managers {
      id
      managerId
      manager {
        name
        role
      }
    }
    managed_customers {
      id
      customer {
        id
      }
    }
  }
`

export const CREATE_ACCOUNT_MANAGER = gql`
  ${CORE_B2B_CUSTOMER_DATA}
  mutation CREATE_B2B_CUSTOMER(
    $name: String!
    $surname: String
    $email: String!
    $default_phone_number: String
    $is_b2b_user: Boolean!
    $b2b_customer_discount: Int
    $b2b_company_name: String
    $b2b_company_code: String
    $b2b_company_vat_code: String
    $b2b_company_website: String
    $phone_number: String!
    $country: String!
    $city: String!
    $postal_code: String!
    $state_region: String
    $address_1: String!
    $address_2: String
    $role: CustomerRole
    $managed_customers: [Int]
    $price_listId: Int
    $account_code: String!
    $imageId: Int
    $spoken_languages: [Language]
    $is_configurator_enabled: Boolean
    $is_claims_enabled: Boolean
    $managers: [Int!]!
    $fabric_palettes: [Int]
  ) {
    createB2Bcustomer(
      name: $name
      surname: $surname
      email: $email
      default_phone_number: $default_phone_number
      is_b2b_user: $is_b2b_user
      b2b_customer_discount: $b2b_customer_discount
      b2b_company_name: $b2b_company_name
      b2b_company_code: $b2b_company_code
      b2b_company_vat_code: $b2b_company_vat_code
      b2b_company_website: $b2b_company_website
      phone_number: $phone_number
      country: $country
      city: $city
      postal_code: $postal_code
      state_region: $state_region
      address_1: $address_1
      address_2: $address_2
      role: $role
      managed_customers: $managed_customers
      price_listId: $price_listId
      account_code: $account_code
      imageId: $imageId
      spoken_languages: $spoken_languages
      is_configurator_enabled: $is_configurator_enabled
      is_claims_enabled: $is_claims_enabled
      managers: $managers
      fabric_palettes: $fabric_palettes
    ) {
      ...CoreB2BCustomerData
    }
  }
`

export const UPDATE_ACCOUNT_MANAGER = gql`
  ${CORE_B2B_CUSTOMER_DATA}
  mutation UPDATE_ACCOUNT_MANAGER(
    $where: CustomerWhereUniqueInput!
    $name: String!
    $surname: String
    $email: String!
    $is_b2b_user: Boolean!
    $b2b_customer_discount: Int
    $b2b_company_name: String
    $b2b_company_code: String
    $b2b_company_vat_code: String
    $b2b_company_website: String
    $phone_number: String!
    $country: String!
    $city: String!
    $postal_code: String!
    $state_region: String
    $address_1: String!
    $address_2: String
    $price_listId: Int
    $account_code: String!
    $imageId: Int
    $spoken_languages: [Language]
    $role: CustomerRole
    $is_configurator_enabled: Boolean
    $is_claims_enabled: Boolean
    $managers: [Int!]!
    $default_phone_number: String
    $fabric_palettes: [Int]
  ) {
    updateB2Bcustomer(
      where: $where
      name: $name
      surname: $surname
      email: $email
      default_phone_number: $default_phone_number
      is_b2b_user: $is_b2b_user
      b2b_customer_discount: $b2b_customer_discount
      b2b_company_name: $b2b_company_name
      b2b_company_code: $b2b_company_code
      b2b_company_vat_code: $b2b_company_vat_code
      b2b_company_website: $b2b_company_website
      phone_number: $phone_number
      country: $country
      city: $city
      postal_code: $postal_code
      state_region: $state_region
      address_1: $address_1
      address_2: $address_2
      price_listId: $price_listId
      account_code: $account_code
      imageId: $imageId
      spoken_languages: $spoken_languages
      is_configurator_enabled: $is_configurator_enabled
      is_claims_enabled: $is_claims_enabled
      role: $role
      managers: $managers
      fabric_palettes: $fabric_palettes
    ) {
      ...CoreB2BCustomerData
    }
  }
`

export const GET_ACCOUNT_MANAGER = gql`
  ${CORE_B2B_CUSTOMER_DATA}
  query GET_ACCOUNT_MANAGER($id: Int!) {
    findUniqueCustomer(where: { id: $id }) {
      ...CoreB2BCustomerData
    }
  }
`
